import React, { Fragment, useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_RESP_STATUS } from "../../Constant/constant";
import { getContactList, getContactTransactionList, deleteContact } from "../Apis/apis";
import AddDailog from "../Record/AddDailog";
import AllStateContext from "../../context/allstateContext";
import AccountDialog from "../Record/AccountDialog";
import DateDialog from "../../Common/DateDialog";
import TimeDialog from "../../Common/TimeDialog";
import { useQuery } from "react-query";
import DeletedConfirmationDialog from "../../Common/DeletedConfirmationDialog";
import AddNewContactDialog from "../../Common/AddNewContactDialog";
import AddNewContactTransactionDialog from "../../Common/AddNewContactTransactionDialog";
import MailStatementDialog from "../../Common/MailStatementDialog";
import moment from "moment";

const ContactTransaction = () => {
  const history = useNavigate();
  const {
    openAccount,
    openDateDialog,
    openTimeDialog,
    openDeleteConfirmationDialog,
    addContactDialog,
    setAddContactDialog,
    addContactTransactionDialog,
    setAddContactTransactionDialog,
    setOpenDeleteConfirmationDialog,
  } = useContext(AllStateContext);

  const [dataT, setDataT] = useState("");
  const [selectedContactId, setSelectedContactId] = useState("");
  const [selectedContactName, setSelectedContactName] = useState("");
  const [transactionType, setTransactionType] = useState(1);
  const [search, setSearch] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [openMailDialog, setOpenMailDialog] = useState(false);
  const [deleteContactId, setDeleteContactId] = useState(null);

  const ledgerEndRef = useRef(null);

  React.useEffect(() => {
    if (ledgerEndRef.current) {
      ledgerEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [dataT]);

  const { data, error, isLoading, refetch } = useQuery(
    ["contactListApiCall"],
    async () => {
      const response = await getContactList();
      return response.data;
    }
  );

  const refreshLedger = async () => {
    refetch();
    if (selectedContactId) {
      const setDataTransaction = await getContactTransactionList({ contactId: selectedContactId });
      setDataT(setDataTransaction.data);
    }
  };

  if (error) {
    if (error.response?.status === API_RESP_STATUS.unauthorized) {
      localStorage.removeItem("token");
      history("/login");
    }
  }

  const contactTransaction = async (item) => {
    setSelectedContactId(item.contactId);
    setSelectedContactName(item.name);
    setDateFrom("");
    setDateTo("");
    const setDataTransaction = await getContactTransactionList({ contactId: item.contactId });
    setDataT(setDataTransaction.data);
  };

  const handelDeleted = async () => {
    if (!deleteContactId) return;
    try {
      await deleteContact(deleteContactId);
      refetch();
      // If the deleted contact was selected, clear the ledger
      if (selectedContactId === deleteContactId) {
        setSelectedContactId("");
        setSelectedContactName("");
        setDataT("");
      }
    } catch (err) {
      console.error("Delete contact failed:", err);
    }
    setDeleteContactId(null);
  };

  // ── Helpers ──────────────────────────────────────────────────────────────
  const getInitials = (name = "") =>
    name.split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2);

  const avatarColor = (name = "") => {
    const colors = [
      "linear-gradient(135deg,#6366f1,#8b5cf6)",
      "linear-gradient(135deg,#0ea5e9,#6366f1)",
      "linear-gradient(135deg,#10b981,#0ea5e9)",
      "linear-gradient(135deg,#f59e0b,#ef4444)",
      "linear-gradient(135deg,#ec4899,#8b5cf6)",
    ];
    let n = 0;
    for (let c of name) n += c.charCodeAt(0);
    return colors[n % colors.length];
  };

  // ── Export CSV ────────────────────────────────────────────────────────────
  const exportCSV = () => {
    const txList = dataT?.payload?.data?.filter((i) => i?.contactsTransactionId) || [];
    if (!txList.length) return;
    const rows = [
      ["Date", "Type", "Amount", "Notes", "Running Balance"],
      ...txList.map((item) => [
        moment(item.billDate || item.createdAt).format("DD MMM YYYY"),
        item.type === 1 ? "Given" : "Received",
        Number(item.amount).toLocaleString("en-IN"),
        item.notes || "",
        "",
      ]),
    ];
    const csv = rows.map((r) => r.map((v) => `"${v}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${selectedContactName}_ledger.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // ── Filtered contact list ─────────────────────────────────────────────────
  const filteredContacts = (data?.payload?.data || [])
    .filter((c) => c.contactId)
    .filter((c) => c.name?.toLowerCase().includes(search.toLowerCase()));

  // ── Filtered & sorted transactions ───────────────────────────────────────
  const getTxData = () => {
    const txList = dataT?.payload?.data?.filter((i) => i?.contactsTransactionId) || [];
    const sorted = [...txList].sort(
      (a, b) => Number(a.contactsTransactionId) - Number(b.contactsTransactionId)
    );
    return sorted.filter((item) => {
      const d = moment(item.billDate || item.createdAt);
      if (dateFrom && d.isBefore(moment(dateFrom), "day")) return false;
      if (dateTo && d.isAfter(moment(dateTo), "day")) return false;
      return true;
    });
  };

  const txFiltered = getTxData();

  // Running balance
  let runningBal = 0;
  const txWithBal = txFiltered.map((item) => {
    const amt = Number(item.amount) || 0;
    if (item.type === 1) runningBal += amt;
    else runningBal -= amt;
    return { ...item, runningBalance: runningBal };
  });

  const finalBalance = runningBal;

  return (
    <div className="container-fluid px-4 contact-container">
      <div className="d-flex flex-column h-100">
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <AddDailog fetchData={refetch} />
            {openAccount && <AccountDialog />}
            {openDateDialog && <DateDialog />}
            {openTimeDialog && <TimeDialog />}
            {addContactDialog && <AddNewContactDialog refetch={refetch} />}
            {addContactTransactionDialog && (
              <AddNewContactTransactionDialog
                contactId={selectedContactId}
                contactName={selectedContactName}
                transactionType={transactionType}
                refetch={refreshLedger}
              />
            )}
            <MailStatementDialog 
              open={openMailDialog} 
              onClose={() => setOpenMailDialog(false)} 
              contactId={selectedContactId}
              contactName={selectedContactName}
            />
            {openDeleteConfirmationDialog && (
              <DeletedConfirmationDialog isDeleted={handelDeleted} />
            )}

            <div className="row g-3 contact-row">
              {/* ═══════════════════════════════════════════
                  LEFT — Contacts list
              ═══════════════════════════════════════════ */}
              <div className="col-12 col-md-4 contact-col">
                <div className="glass-card contact-card" style={{ display: "flex", flexDirection: "column", overflow: "hidden", padding: "0" }}>

                  {/* Header */}
                  <div style={{ padding: "20px 20px 0" }}>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div>
                        <h5 style={{ fontWeight: "800", margin: "0", fontSize: "1.1rem", letterSpacing: "-0.01em" }}>Contacts</h5>
                        <div style={{ fontSize: "0.78rem", color: "var(--text-muted)", marginTop: "2px" }}>
                          {filteredContacts.length} people
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setAddContactDialog(true)}
                        style={{ padding: "7px 14px", fontSize: "0.82rem", fontWeight: "700", borderRadius: "10px", display: "flex", alignItems: "center", gap: "6px" }}
                      >
                        <img style={{ width: "13px", height: "13px" }} src={require("../../Common/Icon/plus.png")} alt="plus" />
                        Add
                      </button>
                    </div>

                    {/* Search */}
                    <div style={{ position: "relative", marginBottom: "16px" }}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="🔍  Search contacts…"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ fontSize: "0.85rem", borderRadius: "10px", paddingLeft: "14px" }}
                      />
                    </div>
                  </div>

                  {/* List */}
                  <div style={{ overflowY: "auto", flex: "1", minHeight: 0 }}>
                    {filteredContacts.length > 0 ? (
                      filteredContacts.map((item) => {
                        const isSelected = selectedContactId === item.contactId;
                        const isDue = item.balance > 0;
                        return (
                          <div
                            key={item.contactId}
                            onClick={() => contactTransaction(item)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                              padding: "12px 20px",
                              cursor: "pointer",
                              borderLeft: isSelected ? "3px solid var(--primary)" : "3px solid transparent",
                              backgroundColor: isSelected ? "var(--bg-surface-hover)" : "transparent",
                              borderBottom: "1px solid var(--border-color)",
                              transition: "all 0.18s ease",
                            }}
                          >
                            {/* Avatar */}
                            <div style={{
                              width: "44px", height: "44px", borderRadius: "50%",
                              background: avatarColor(item.name),
                              display: "flex", alignItems: "center", justifyContent: "center",
                              fontSize: "0.85rem", fontWeight: "800", color: "#fff",
                              flexShrink: 0, letterSpacing: "0.03em",
                              boxShadow: isSelected ? "0 0 0 3px rgba(99,102,241,0.3)" : "none",
                            }}>
                              {getInitials(item.name)}
                            </div>

                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ fontWeight: "700", fontSize: "0.9rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {item.name}
                              </div>
                              <div style={{ fontSize: "0.78rem", fontWeight: "600", color: isDue ? "var(--danger)" : "var(--success)", marginTop: "1px" }}>
                                {isDue
                                  ? `Due ₹${Math.abs(item.balance || 0).toLocaleString("en-IN")}`
                                  : `Advance ₹${(item.balance || 0).toLocaleString("en-IN")}`}
                              </div>
                            </div>

                            {/* Balance chip */}
                            <div style={{
                              fontSize: "0.72rem", fontWeight: "700",
                              padding: "3px 8px", borderRadius: "20px",
                              background: isDue ? "var(--danger-glow)" : "var(--success-glow)",
                              color: isDue ? "var(--danger)" : "var(--success)",
                              border: `1px solid ${isDue ? "rgba(220,38,38,0.2)" : "rgba(5,150,105,0.2)"}`,
                              flexShrink: 0,
                            }}>
                              {isDue ? "Due" : "Adv"}
                            </div>

                            {/* Delete button */}
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteContactId(item.contactId);
                                setOpenDeleteConfirmationDialog(true);
                              }}
                              className="btn btn-secondary"
                              style={{
                                width: "28px", height: "28px", padding: "0", minWidth: "28px",
                                borderRadius: "8px", background: "rgba(239, 68, 68, 0.05)",
                                borderColor: "rgba(239, 68, 68, 0.1)", flexShrink: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                              }}
                              title="Delete contact"
                            >
                              <img style={{ width: "11px", height: "11px", filter: "invert(1)" }} src={require("../../Common/Icon/delete_icon.png")} alt="delete" />
                            </button>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center py-5 text-muted" style={{ fontSize: "0.9rem" }}>
                        {search ? "No contacts match." : "No contacts yet."}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* ═══════════════════════════════════════════
                  RIGHT — Transaction ledger
              ═══════════════════════════════════════════ */}
              <div className="col-12 col-md-8 contact-col">
                <div className="glass-card contact-card" style={{ display: "flex", flexDirection: "column", overflow: "hidden", padding: "0" }}>

                  {dataT ? (
                    <div style={{ flex: "1", display: "flex", flexDirection: "column", minHeight: 0 }}>

                      {/* Ledger header */}
                      <div style={{ padding: "20px 20px 0" }}>
                        {/* Contact name + export */}
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-center gap-3">
                            <div style={{
                              width: "46px", height: "46px", borderRadius: "50%",
                              background: avatarColor(selectedContactName),
                              display: "flex", alignItems: "center", justifyContent: "center",
                              fontSize: "0.9rem", fontWeight: "800", color: "#fff",
                              flexShrink: 0,
                            }}>
                              {getInitials(selectedContactName)}
                            </div>
                            <div>
                              <div style={{ fontWeight: "800", fontSize: "1.05rem" }}>{selectedContactName}</div>
                              <div style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>
                                {txFiltered.length} transaction{txFiltered.length !== 1 ? "s" : ""}
                              </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            {/* Date filter toggle */}
                            <button
                              className="btn btn-secondary"
                              style={{ padding: "6px 12px", fontSize: "0.8rem", fontWeight: "600", borderRadius: "10px", borderColor: "var(--border-color)", background: showDateFilter ? "var(--primary)" : "var(--bg-surface-hover)", color: showDateFilter ? "#fff" : "var(--text-secondary)" }}
                              onClick={() => setShowDateFilter(!showDateFilter)}
                            >
                              📅 Filter
                            </button>
                            {/* Export CSV */}
                            <button
                              className="btn btn-secondary"
                              style={{ padding: "6px 12px", fontSize: "0.8rem", fontWeight: "600", borderRadius: "10px", borderColor: "var(--border-color)", background: "var(--bg-surface-hover)", color: "var(--text-secondary)" }}
                              onClick={exportCSV}
                            >
                              ⬇ CSV
                            </button>
                            {/* Mail Statement */}
                            <button
                              className="btn btn-primary shadow-sm"
                              style={{ padding: "6px 12px", fontSize: "0.8rem", fontWeight: "600", borderRadius: "10px" }}
                              onClick={() => setOpenMailDialog(true)}
                            >
                              ✉ Mail Statement
                            </button>
                          </div>
                        </div>

                        {/* Date range filter bar */}
                        {showDateFilter && (
                          <div style={{ display: "flex", gap: "10px", marginBottom: "14px", alignItems: "center", flexWrap: "wrap" }}>
                            <div style={{ flex: 1, minWidth: "130px" }}>
                              <label style={{ fontSize: "0.72rem", fontWeight: "700", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.04em", display: "block", marginBottom: "4px" }}>From</label>
                              <input type="date" className="form-control" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} style={{ fontSize: "0.85rem", borderRadius: "8px", height: "36px" }} />
                            </div>
                            <div style={{ flex: 1, minWidth: "130px" }}>
                              <label style={{ fontSize: "0.72rem", fontWeight: "700", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.04em", display: "block", marginBottom: "4px" }}>To</label>
                              <input type="date" className="form-control" value={dateTo} onChange={(e) => setDateTo(e.target.value)} style={{ fontSize: "0.85rem", borderRadius: "8px", height: "36px" }} />
                            </div>
                            {(dateFrom || dateTo) && (
                              <button className="btn btn-secondary" style={{ marginTop: "18px", padding: "4px 12px", fontSize: "0.78rem", borderRadius: "8px", borderColor: "var(--border-color)" }} onClick={() => { setDateFrom(""); setDateTo(""); }}>
                                Clear
                              </button>
                            )}
                          </div>
                        )}

                        {/* Balance status card */}
                        <div style={{
                          borderRadius: "12px",
                          padding: "14px 20px",
                          marginBottom: "16px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          background: finalBalance > 0
                            ? "var(--danger-glow)"
                            : finalBalance < 0
                              ? "var(--success-glow)"
                              : "var(--bg-surface)",
                          border: `1px solid ${finalBalance > 0 ? "rgba(220,38,38,0.25)" : finalBalance < 0 ? "rgba(5,150,105,0.25)" : "var(--border-color)"}`,
                        }}>
                          <div>
                            <div style={{ fontSize: "0.72rem", fontWeight: "700", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.05em" }}>Balance Status</div>
                            <div style={{ fontSize: "1.4rem", fontWeight: "900", color: finalBalance > 0 ? "var(--danger)" : finalBalance < 0 ? "var(--success)" : "var(--text-muted)", marginTop: "2px", letterSpacing: "-0.02em" }}>
                              {finalBalance > 0
                                ? `₹${finalBalance.toLocaleString("en-IN")} Due`
                                : finalBalance < 0
                                  ? `₹${Math.abs(finalBalance).toLocaleString("en-IN")} Advance`
                                  : "Settled ✓"}
                            </div>
                          </div>
                          {finalBalance !== 0 && (
                            <div style={{
                              width: "48px", height: "48px", borderRadius: "50%",
                              background: finalBalance > 0 ? "var(--danger)" : "var(--success)",
                              display: "flex", alignItems: "center", justifyContent: "center",
                              fontSize: "1.4rem",
                              boxShadow: finalBalance > 0 ? "0 0 16px rgba(220,38,38,0.4)" : "0 0 16px rgba(5,150,105,0.4)",
                              animation: Math.abs(finalBalance) > 1000 ? "pulse 2s infinite" : "none",
                            }}>
                              {finalBalance > 0 ? "↑" : "↓"}
                            </div>
                          )}
                        </div>

                        {/* divider */}
                        <div style={{ borderBottom: "1px solid var(--border-color)", marginLeft: "-20px", marginRight: "-20px" }} />
                      </div>

                      {/* Chat bubble area */}
                      <div style={{
                        flex: "1", overflowY: "auto", padding: "16px 20px",
                        display: "flex", flexDirection: "column", gap: "12px", minHeight: 0,
                      }}>
                        {txWithBal.length > 0 ? (() => {
                          let lastDateStr = "";
                          return (
                            <Fragment>
                              {txWithBal.map((item) => {
                                const isGiven = item.type === 1;
                                const amt = Number(item.amount) || 0;
                                const currentDateStr = moment(item.billDate || item.createdAt).format("DD MMM YYYY");
                                const showDate = currentDateStr !== lastDateStr;
                                if (showDate) lastDateStr = currentDateStr;
                                return (
                                  <Fragment key={item.contactsTransactionId}>
                                    {showDate && (
                                      <div className="d-flex justify-content-center my-1">
                                        <span style={{
                                          background: "var(--date-chip-bg, rgba(255,255,255,0.08))",
                                          border: "1px solid var(--date-chip-border, rgba(255,255,255,0.08))",
                                          color: "var(--date-chip-color, rgba(255,255,255,0.6))",
                                          fontSize: "0.72rem", fontWeight: "700",
                                          padding: "3px 12px", borderRadius: "20px", letterSpacing: "0.03em",
                                        }}>
                                          {currentDateStr}
                                        </span>
                                      </div>
                                    )}
                                    <div style={{ alignSelf: isGiven ? "flex-end" : "flex-start", maxWidth: "72%", minWidth: "180px" }}>
                                      <div style={{
                                        padding: "11px 15px",
                                        borderRadius: isGiven ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
                                        backgroundColor: isGiven
                                          ? "var(--bubble-gave-bg, rgba(239,83,80,0.08))"
                                          : "var(--bubble-got-bg, rgba(102,187,106,0.08))",
                                        border: isGiven
                                          ? "1px solid var(--bubble-gave-border, rgba(239,83,80,0.2))"
                                          : "1px solid var(--bubble-got-border, rgba(102,187,106,0.2))",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                                      }}>
                                        {/* Amount row */}
                                        <div className="d-flex justify-content-between align-items-center gap-3 mb-1">
                                          <span style={{ fontSize: "1.15rem", fontWeight: "900", color: isGiven ? "var(--danger)" : "var(--success)", letterSpacing: "-0.01em" }}>
                                            {isGiven ? "↑" : "↓"} ₹{amt.toLocaleString("en-IN")}
                                          </span>
                                          <span style={{ fontSize: "0.68rem", color: "var(--text-muted)", whiteSpace: "nowrap" }}>
                                            {moment(item.billDate || item.createdAt).format("h:mm a")}
                                          </span>
                                        </div>

                                        {/* Notes */}
                                        <div style={{ fontSize: "0.83rem", color: item.notes ? "var(--text-primary)" : "var(--text-muted)", fontStyle: item.notes ? "normal" : "italic", wordBreak: "break-word", lineHeight: "1.4" }}>
                                          {item.notes || "No note added"}
                                        </div>
                                      </div>

                                      {/* Running balance */}
                                      <div style={{ fontSize: "0.7rem", fontWeight: "600", color: "var(--text-secondary)", textAlign: isGiven ? "right" : "left", marginTop: "3px", padding: isGiven ? "0 4px 0 0" : "0 0 0 4px" }}>
                                        {item.runningBalance > 0
                                          ? `₹${item.runningBalance.toLocaleString("en-IN")} due`
                                          : item.runningBalance < 0
                                            ? `₹${Math.abs(item.runningBalance).toLocaleString("en-IN")} advance`
                                            : "Settled"}
                                      </div>
                                    </div>
                                  </Fragment>
                                );
                              })}
                              <div ref={ledgerEndRef} />
                            </Fragment>
                          );
                        })() : (
                          <div className="text-center py-4 text-muted" style={{ fontSize: "0.88rem" }}>
                            {(dateFrom || dateTo) ? "No transactions in selected date range." : "No transactions yet."}
                          </div>
                        )}
                      </div>

                      {/* Footer actions */}
                      <div style={{ padding: "16px 20px", borderTop: "1px solid var(--border-color)", display: "flex", gap: "12px" }}>
                        <button
                          type="button"
                          className="btn btn-outline-success"
                          style={{ flex: "1", padding: "11px", fontSize: "0.88rem", fontWeight: "700", borderRadius: "12px" }}
                          onClick={() => { setTransactionType(2); setAddContactTransactionDialog(true); }}
                        >
                          ↓ Record Received
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          style={{ flex: "1", padding: "11px", fontSize: "0.88rem", fontWeight: "700", borderRadius: "12px" }}
                          onClick={() => { setTransactionType(1); setAddContactTransactionDialog(true); }}
                        >
                          ↑ Record Given
                        </button>
                      </div>
                    </div>
                  ) : (
                    /* Empty state */
                    <div className="d-flex flex-column align-items-center justify-content-center text-muted" style={{ height: "100%", width: "100%", padding: "40px" }}>
                      <div style={{ fontSize: "3.5rem", marginBottom: "16px", opacity: 0.3 }}>💬</div>
                      <div style={{ fontWeight: "700", fontSize: "1rem", marginBottom: "6px", color: "var(--text-secondary)" }}>
                        Select a Contact
                      </div>
                      <div style={{ fontSize: "0.85rem", color: "var(--text-muted)", textAlign: "center" }}>
                        Choose a contact from the left to view their transaction history
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Pulse animation for large balance */}
      <style>{`
        @keyframes pulse {
          0%, 100% { box-shadow: 0 0 16px rgba(220,38,38,0.4); }
          50% { box-shadow: 0 0 28px rgba(220,38,38,0.7), 0 0 0 6px rgba(220,38,38,0.1); }
        }
      `}</style>
    </div>
  );
};

export default ContactTransaction;
